import React from 'react';
import { SectionTitle } from './SectionTitle';
import { bonuses } from '../data/salesCopy';
export function BonusSection() {
  return <section className="bg-brand-ivory px-4 py-8 sm:py-10" data-id="element-31" data-mp="1ofc49qi2clfd">
      <div className="mx-auto max-w-3xl" data-id="element-32" data-mp="22g51iizr1um6">
        <SectionTitle data-id="element-33" data-mp="22etzoopv6wxp">🎁 4 bonus professionnels inclus</SectionTitle>

        <div className="mt-5 space-y-2.5" data-id="element-34" data-mp="1yf30bwm9v8hk">
          {bonuses.map(bonus => <article key={bonus.n} className="overflow-hidden rounded-lg border-2 border-brand-gold/60 bg-white shadow-sm" data-id="element-35" data-mp="1anxn7p7puuay">
              <header className="bg-brand-gold/15 px-3 py-2 sm:px-4" data-id="element-36" data-mp="15njb9w2zv07n">
                <div className="flex items-center gap-2" data-id="element-37" data-mp="1jibxfdde3en7">
                  <span className="shrink-0 rounded bg-brand-gold px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-wider text-white" data-id="element-38" data-mp="1episophx86b4">
                    Bonus {bonus.n}
                  </span>
                  <h3 className="font-serif text-base font-bold uppercase leading-tight text-brand-brown sm:text-xl" data-id="element-39" data-mp="mzeb0yljpxdl">
                    {bonus.title}
                  </h3>
                </div>
                <p className="mt-1 text-[11.5px] font-semibold uppercase tracking-wide text-brand-taupe" data-id="element-40" data-mp="2eqo0r8g5pywz">
                  {bonus.subtitle}
                </p>
              </header>

              <div className="space-y-2 p-3 sm:p-4" data-id="element-41" data-mp="2ogpsca7pxzgn">
                {bonus.paras.map(p => <p key={p} className="text-[12.5px] font-medium leading-snug text-brand-brown/85 sm:text-[13.5px]" data-id="element-42" data-mp="1qtgztv9avq55">
                    {p}
                  </p>)}
                <p className="border-t border-brand-sand pt-2 text-[12.5px] font-bold uppercase leading-snug tracking-wide text-brand-taupe sm:text-[13.5px]" data-id="element-43" data-mp="20qlpi52cu3qp">
                  {bonus.close}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}